export const reconContact = {
  title : "contact_recon_title",
  description: "contact_recon_description"
}